@if ((!columns || columns.length === 0) && showNoResultsMessage) {
    <p>{{noResultsText}}</p>
}
<table class="resultsList">
    <tr *ngFor="let column of columns; let idx = index;">
        @if (listType !== 'Text') {
            <td class="resultsListTableLabel" [ngClass]="{'resultsListTableItem': (listType==='Table')}">
                {{headers[idx].text}}
            </td>
            <td [style.text-align]="column.alignment" [ngClass]="{'resultsListTableItem': (listType==='Table')}">
                @if (column.specialType === 'image') {
                    <img [src]="'data:image/gif;base64,' + column.value" alt="" [ngStyle]="{'height': column.imageHeight > 0 ? column.imageHeight + 'px' : -1,
                                                            'width': column.imageWidth > 0 ? column.imageWidth + 'px' : -1}" />
                } @else {
                    @if (column.specialType === 'iostring') {
                        @if (column.value !== '') {
                            <span>{{column.value}}</span>
                        }
                        @if (!column.value && column.value === '') {
                            <input [id]="column.name + '_'" type="text" />
                        }
                    }
                    @if ((!column.linkTarget || column.linkTarget === '') && column.specialType !== 'iostring' && column.imageWidth === -1) {
                        <span>{{column.value}}</span>
                    }
                    @if ((!column.linkTarget || column.linkTarget === '') && column.specialType !== 'iostring' && column.imageWidth > -1) {
                        <span>
                            @if (column.value && column.value !== '') {
                                <img [src]="imageLocation + column.value" alt='' />
                            }
                        </span>
                    }
                    @if (column.linkTarget && column.linkTarget !== '') {
                        @switch (column.linkTarget) {
                            @case ('image') {
                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" [height]="column.imageHeight" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                            }
                            @case ('imageUrl') {
                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" [height]="column.imageHeight" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                            }
                            @case ('anchor') {
                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                            }
                            @case ('anchorUrl') {
                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                            }
                            @case ('filestream/string') {
                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                            }
                            @case ('dataquery/string') {
                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                            }
                            @case ('dataquery/image') {
                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                            }
                            @case ('filestream/image') {
                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                            }
                            @case ('filestream/iframe') {
                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                            }
                        }
                    }
                }
            </td>
        } @else {
            <td>
                <label class="resultsListTextLabel">{{headers[idx].text}}</label>
                @if (column.specialType === 'image') {
                    <img [src]="'data:image/gif;base64,' + column.value" alt="" [ngStyle]="{
                        'height': column.imageHeight > 0 ? column.imageHeight + 'px' : -1,
                        'width': column.imageWidth > 0 ? column.imageWidth + 'px' : -1}" />
                } @else {
                    @if (!column.linkTarget || column.linkTarget === '') {
                        <span>{{column.value}}</span>
                    }
                    @if (column.linkTarget && column.linkTarget !== '') {
                        @switch (column.linkTarget) {
                            @case ('image') {
                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" [height]="column.imageHeight" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                            }
                            @case ('imageUrl') {
                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" [height]="column.imageHeight" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                            }
                            @case ('anchor') {
                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                            }
                            @case ('anchorUrl') {
                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                            }
                            @case ('filestream/string') {
                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                            }
                            @case ('dataquery/string') {
                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                            }
                            @case ('dataquery/image') {
                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                            }
                            @case ('filestream/image') {
                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                            }
                            @case ('filestream/iframe') {
                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                            }
                        }
                    }
                }
            </td>
        }
    </tr>
</table>
